import _extends from "@babel/runtime/helpers/esm/extends";
import generateUtilityClass from '@mui/utils/generateUtilityClass';
import generateUtilityClasses from '@mui/utils/generateUtilityClasses';
import composeClasses from '@mui/utils/composeClasses';
import { eventDialogClassKeys, eventDialogSlots } from "../internals/components/event-dialog/eventDialogClasses.mjs";
export function getEventCalendarUtilityClass(slot) {
  return generateUtilityClass('MuiEventCalendar', slot);
}
export const eventCalendarClasses = generateUtilityClasses('MuiEventCalendar', ['root', 'sidePanel', 'mainPanel', 'content', 'miniCalendar', 'miniCalendarHeader', 'miniCalendarNavigation', 'miniCalendarMonthLabel', 'miniCalendarWeekdayHeader', 'miniCalendarWeekdayCell', 'miniCalendarGrid', 'miniCalendarWeekRow', 'miniCalendarDayCell', 'miniCalendarDayButton', 'errorContainer', 'errorAlert', 'errorMessage', 'headerToolbar', 'headerToolbarActions', 'headerToolbarLeftElement', 'headerToolbarLabel', 'headerToolbarDateNavigator', 'viewSwitcher', 'preferencesMenu', 'resourcesTree', 'resourcesTreeLabel', 'resourcesTreeItem', 'resourcesTreeItemLabel', 'resourcesTreeItemCheckbox', 'agendaView', 'agendaViewRow', 'agendaViewDayHeaderCell', 'agendaViewDayNumberCell', 'agendaViewWeekDayCell', 'agendaViewWeekDayNameLabel', 'agendaViewYearAndMonthLabel', 'agendaViewEventsList', 'agendaViewWeekNumberLabel', 'agendaViewWeekNumberRow', 'eventSkeleton', 'monthView', 'monthViewGrid', 'monthViewHeader', 'monthViewHeaderCell', 'monthViewWeekHeaderCell', 'monthViewBody', 'monthViewRow', 'monthViewWeekNumberCell', 'monthViewCell', 'monthViewCellNumber', 'monthViewCellNumberButton', 'monthViewCellEvents', 'monthViewMoreEvents', 'monthViewPlaceholderContainer', 'dayTimeGridContainer', 'dayTimeGrid', 'dayTimeGridHeader', 'dayTimeGridHeaderCell', 'dayTimeGridAllDayEventsGrid', 'dayTimeGridAllDayEventsRow', 'dayTimeGridAllDayEventsCell', 'dayTimeGridAllDayEventsHeaderCell', 'dayTimeGridHeaderContent', 'dayTimeGridHeaderButton', 'dayTimeGridHeaderDayName', 'dayTimeGridHeaderDayNumber', 'dayTimeGridBody', 'dayTimeGridScrollableContent', 'dayTimeGridTimeAxis', 'dayTimeGridTimeAxisCell', 'dayTimeGridTimeAxisText', 'dayTimeGridGrid', 'dayTimeGridColumn', 'dayTimeGridColumnInteractiveLayer', 'dayTimeGridCurrentTimeIndicator', 'dayTimeGridCurrentTimeIndicatorCircle', 'dayTimeGridCurrentTimeLabel', 'dayTimeGridAllDayEventsCellEvents', 'dayTimeGridAllDayEventContainer', 'dayTimeGridScrollablePlaceholder', 'dayGridEvent', 'dayGridEventPlaceholder', 'dayGridEventTitle', 'dayGridEventTime', 'dayGridEventRecurringIcon', 'dayGridEventResizeHandler', 'dayGridEventCardWrapper', 'dayGridEventCardContent', 'dayGridEventLinesClamp', 'eventColorIndicator', 'timeGridEvent', 'timeGridEventPlaceholder', 'timeGridEventSkeleton', 'timeGridEventTitle', 'timeGridEventTime', 'timeGridEventRecurringIcon', 'timeGridEventResizeHandler', 'eventItemCard', 'eventItemCardWrapper', 'eventItemTitle', 'eventItemTime', 'eventItemRecurringIcon', 'resourceLegendColor', 'eventItemCardContent', 'eventItemLinesClamp', 'moreEventsPopoverHeader', 'moreEventsPopoverTitle', 'moreEventsPopoverBody', 'eventDragPreview', 'standaloneEvent', 'agendaViewEventListItem', 'sidePanelCollapse', 'sidePanelDivider', 'headerToolbarSidePanelToggle', 'headerToolbarPreviousButton', 'headerToolbarTodayButton', 'headerToolbarNextButton', 'headerToolbarWeekNumber', 'preferencesMenuButton', 'preferencesMenuList', 'preferencesMenuListItemIcon', 'preferencesMenuListSubheader', 'preferencesMenuItem', 'preferencesMenuDivider', 'preferencesMenuListItemText', 'viewSwitcherButton', 'viewSwitcherMenu', 'miniCalendarPreviousButton', 'miniCalendarNextButton', 'moreEventsPopover', ...eventDialogClassKeys]);
const slots = _extends({
  root: ['root'],
  sidePanel: ['sidePanel'],
  mainPanel: ['mainPanel'],
  content: ['content'],
  miniCalendar: ['miniCalendar'],
  miniCalendarHeader: ['miniCalendarHeader'],
  miniCalendarNavigation: ['miniCalendarNavigation'],
  miniCalendarMonthLabel: ['miniCalendarMonthLabel'],
  miniCalendarWeekdayHeader: ['miniCalendarWeekdayHeader'],
  miniCalendarWeekdayCell: ['miniCalendarWeekdayCell'],
  miniCalendarGrid: ['miniCalendarGrid'],
  miniCalendarWeekRow: ['miniCalendarWeekRow'],
  miniCalendarDayCell: ['miniCalendarDayCell'],
  miniCalendarDayButton: ['miniCalendarDayButton'],
  errorContainer: ['errorContainer'],
  errorAlert: ['errorAlert'],
  errorMessage: ['errorMessage'],
  headerToolbar: ['headerToolbar'],
  headerToolbarActions: ['headerToolbarActions'],
  headerToolbarLeftElement: ['headerToolbarLeftElement'],
  headerToolbarLabel: ['headerToolbarLabel'],
  headerToolbarDateNavigator: ['headerToolbarDateNavigator'],
  viewSwitcher: ['viewSwitcher'],
  preferencesMenu: ['preferencesMenu'],
  resourcesTree: ['resourcesTree'],
  resourcesTreeLabel: ['resourcesTreeLabel'],
  resourcesTreeItem: ['resourcesTreeItem'],
  resourcesTreeItemLabel: ['resourcesTreeItemLabel'],
  resourcesTreeItemCheckbox: ['resourcesTreeItemCheckbox'],
  agendaView: ['agendaView'],
  agendaViewRow: ['agendaViewRow'],
  agendaViewDayHeaderCell: ['agendaViewDayHeaderCell'],
  agendaViewDayNumberCell: ['agendaViewDayNumberCell'],
  agendaViewWeekDayCell: ['agendaViewWeekDayCell'],
  agendaViewWeekDayNameLabel: ['agendaViewWeekDayNameLabel'],
  agendaViewYearAndMonthLabel: ['agendaViewYearAndMonthLabel'],
  agendaViewEventsList: ['agendaViewEventsList'],
  agendaViewWeekNumberLabel: ['agendaViewWeekNumberLabel'],
  agendaViewWeekNumberRow: ['agendaViewWeekNumberRow'],
  eventSkeleton: ['eventSkeleton'],
  monthView: ['monthView'],
  monthViewGrid: ['monthViewGrid'],
  monthViewHeader: ['monthViewHeader'],
  monthViewHeaderCell: ['monthViewHeaderCell'],
  monthViewWeekHeaderCell: ['monthViewWeekHeaderCell'],
  monthViewBody: ['monthViewBody'],
  monthViewRow: ['monthViewRow'],
  monthViewWeekNumberCell: ['monthViewWeekNumberCell'],
  monthViewCell: ['monthViewCell'],
  monthViewCellNumber: ['monthViewCellNumber'],
  monthViewCellNumberButton: ['monthViewCellNumberButton'],
  monthViewCellEvents: ['monthViewCellEvents'],
  monthViewMoreEvents: ['monthViewMoreEvents'],
  monthViewPlaceholderContainer: ['monthViewPlaceholderContainer'],
  dayTimeGridContainer: ['dayTimeGridContainer'],
  dayTimeGrid: ['dayTimeGrid'],
  dayTimeGridHeader: ['dayTimeGridHeader'],
  dayTimeGridHeaderCell: ['dayTimeGridHeaderCell'],
  dayTimeGridAllDayEventsGrid: ['dayTimeGridAllDayEventsGrid'],
  dayTimeGridAllDayEventsRow: ['dayTimeGridAllDayEventsRow'],
  dayTimeGridAllDayEventsCell: ['dayTimeGridAllDayEventsCell'],
  dayTimeGridAllDayEventsHeaderCell: ['dayTimeGridAllDayEventsHeaderCell'],
  dayTimeGridHeaderContent: ['dayTimeGridHeaderContent'],
  dayTimeGridHeaderButton: ['dayTimeGridHeaderButton'],
  dayTimeGridHeaderDayName: ['dayTimeGridHeaderDayName'],
  dayTimeGridHeaderDayNumber: ['dayTimeGridHeaderDayNumber'],
  dayTimeGridBody: ['dayTimeGridBody'],
  dayTimeGridScrollableContent: ['dayTimeGridScrollableContent'],
  dayTimeGridTimeAxis: ['dayTimeGridTimeAxis'],
  dayTimeGridTimeAxisCell: ['dayTimeGridTimeAxisCell'],
  dayTimeGridTimeAxisText: ['dayTimeGridTimeAxisText'],
  dayTimeGridGrid: ['dayTimeGridGrid'],
  dayTimeGridColumn: ['dayTimeGridColumn'],
  dayTimeGridColumnInteractiveLayer: ['dayTimeGridColumnInteractiveLayer'],
  dayTimeGridCurrentTimeIndicator: ['dayTimeGridCurrentTimeIndicator'],
  dayTimeGridCurrentTimeIndicatorCircle: ['dayTimeGridCurrentTimeIndicatorCircle'],
  dayTimeGridCurrentTimeLabel: ['dayTimeGridCurrentTimeLabel'],
  dayTimeGridAllDayEventsCellEvents: ['dayTimeGridAllDayEventsCellEvents'],
  dayTimeGridAllDayEventContainer: ['dayTimeGridAllDayEventContainer'],
  dayTimeGridScrollablePlaceholder: ['dayTimeGridScrollablePlaceholder'],
  dayGridEvent: ['dayGridEvent'],
  dayGridEventPlaceholder: ['dayGridEventPlaceholder'],
  dayGridEventTitle: ['dayGridEventTitle'],
  dayGridEventTime: ['dayGridEventTime'],
  dayGridEventRecurringIcon: ['dayGridEventRecurringIcon'],
  dayGridEventResizeHandler: ['dayGridEventResizeHandler'],
  dayGridEventCardWrapper: ['dayGridEventCardWrapper'],
  dayGridEventCardContent: ['dayGridEventCardContent'],
  dayGridEventLinesClamp: ['dayGridEventLinesClamp'],
  eventColorIndicator: ['eventColorIndicator'],
  timeGridEvent: ['timeGridEvent'],
  timeGridEventPlaceholder: ['timeGridEventPlaceholder'],
  timeGridEventSkeleton: ['timeGridEventSkeleton'],
  timeGridEventTitle: ['timeGridEventTitle'],
  timeGridEventTime: ['timeGridEventTime'],
  timeGridEventRecurringIcon: ['timeGridEventRecurringIcon'],
  timeGridEventResizeHandler: ['timeGridEventResizeHandler'],
  eventItemCard: ['eventItemCard'],
  eventItemCardWrapper: ['eventItemCardWrapper'],
  eventItemTitle: ['eventItemTitle'],
  eventItemTime: ['eventItemTime'],
  eventItemRecurringIcon: ['eventItemRecurringIcon'],
  resourceLegendColor: ['resourceLegendColor'],
  eventItemCardContent: ['eventItemCardContent'],
  eventItemLinesClamp: ['eventItemLinesClamp'],
  moreEventsPopoverHeader: ['moreEventsPopoverHeader'],
  moreEventsPopoverTitle: ['moreEventsPopoverTitle'],
  moreEventsPopoverBody: ['moreEventsPopoverBody'],
  eventDragPreview: ['eventDragPreview'],
  standaloneEvent: ['standaloneEvent'],
  agendaViewEventListItem: ['agendaViewEventListItem'],
  sidePanelCollapse: ['sidePanelCollapse'],
  sidePanelDivider: ['sidePanelDivider'],
  headerToolbarSidePanelToggle: ['headerToolbarSidePanelToggle'],
  headerToolbarPreviousButton: ['headerToolbarPreviousButton'],
  headerToolbarTodayButton: ['headerToolbarTodayButton'],
  headerToolbarNextButton: ['headerToolbarNextButton'],
  headerToolbarWeekNumber: ['headerToolbarWeekNumber'],
  preferencesMenuButton: ['preferencesMenuButton'],
  preferencesMenuList: ['preferencesMenuList'],
  preferencesMenuListItemIcon: ['preferencesMenuListItemIcon'],
  preferencesMenuListSubheader: ['preferencesMenuListSubheader'],
  preferencesMenuItem: ['preferencesMenuItem'],
  preferencesMenuDivider: ['preferencesMenuDivider'],
  preferencesMenuListItemText: ['preferencesMenuListItemText'],
  viewSwitcherButton: ['viewSwitcherButton'],
  viewSwitcherMenu: ['viewSwitcherMenu'],
  miniCalendarPreviousButton: ['miniCalendarPreviousButton'],
  miniCalendarNextButton: ['miniCalendarNextButton'],
  moreEventsPopover: ['moreEventsPopover']
}, eventDialogSlots);

/**
 * Computes the utility classes for EventCalendar components.
 * Exported so both EventCalendar and EventCalendarPremium can use it.
 */
export const useEventCalendarUtilityClasses = classes => {
  return composeClasses(slots, getEventCalendarUtilityClass, classes);
};